import dayjs from 'dayjs'
import L from 'leaflet'
import 'leaflet-textpath'
import { merge } from 'lodash-unified'

export const CommUtils = {
  CHINA_BODER: [
    [40.29627734069808, 124.6948101392579],
    [39.5972267104164, 124.11255587894543],
    [39.44890871319574, 123.34898341051989],
    [39.00211537046493, 123.12378263398612],
    [38.831158741524675, 122.15699536756337],
    [38.61688332693384, 121.5252870064447],
    [38.57822420886194, 121.06383233006642],
    [38.8739308592928, 120.88806431122265],
    [39.4404439294106, 121.15174412274202],
    [39.96871610923454, 121.47585011126309],
    [40.35071479769971, 122.00315544518345],
    [40.517983247636494, 121.84388574961835],
    [40.61396723249586, 121.49782473890032],
    [40.61811500242605, 121.27806734211637],
    [40.12849032670938, 120.74523840470067],
    [39.82117697631994, 120.00913860949409],
    [39.44042791038892, 119.6246292096556],
    [39.0618555156502, 119.21265537043641],
    [38.84397463715443, 118.67979602770767],
    [38.62545588635019, 118.58642924339169],
    [38.36318781967069, 118.92699217664267],
    [38.03079502043924, 119.43238630125137],
    [37.692519130598725, 119.77296018126424],
    [38.19501433359099, 120.64086010616799],
    [37.95286359719455, 121.2341333378185],
    [37.683829102283, 121.82740634971174],
    [37.45742673170285, 122.81616996669459],
    [36.75648414569666, 122.92601449727579],
    [36.394765944992976, 122.16798158473269],
    [35.75543637425928, 121.19019558495245],
    [35.173803366800854, 120.71776723347901],
    [34.58799282186823, 120.71776739834384],
    [32.962591224294634, 121.77246751731724],
    [31.662743633613125, 122.53052969215035],
    [30.524406057126036, 123.2995499503723],
    [29.113784984081622, 122.82715452717251],
    [27.362016514722864, 121.7834541813496],
    [25.740539350498306, 120.4870760716402],
    [24.20687951366758, 118.94896451671647],
    [23.352335758848977, 117.6965257839707],
    [22.466869505158872, 116.33971380392327],
    [22.329746775249067, 114.92247964152898],
    [22.388174654465878, 114.59015119927648],
    [22.433886946383172, 114.43772489454962],
    [22.5607479551203, 114.32921677542767],
    [22.53793638263667, 114.15757554419271],
    [22.475747303061777, 113.97215710786733],
    [22.352611675437526, 113.72772101493868],
    [22.300196211804582, 113.67781445927564],
    [22.248581970279023, 113.60799165359187],
    [22.20053929829942, 113.587005137053],
    [22.20060625272292, 113.56840234331355],
    [22.200551561045103, 113.55718142816825],
    [22.200447837132526, 113.54393304423787],
    [22.183692964365015, 113.54409545560334],
    [22.165623501677295, 113.54411811794553],
    [22.15984833504321, 113.54415075399785],
    [22.1598007569129, 113.57149935060934],
    [22.109194262420583, 113.57163147236194],
    [22.10880647926152, 113.59349447256177],
    [22.1554039293889, 113.7174343391062],
    [22.18337161233124, 113.81110590202827],
    [22.160795137142017, 113.81429144405736],
    [22.15502998892399, 113.81448544038236],
    [22.149389146459864, 113.81749787342235],
    [22.15097001317185, 113.8334835737316],
    [22.113125524435052, 113.84277980430052],
    [22.0385934268131, 113.74216011362316],
    [21.977201970308233, 113.81111893053118],
    [21.68323340915434, 113.71123870189228],
    [21.47128990789753, 113.35280484783203],
    [21.383853241415597, 112.93944237788966],
    [21.401928807933707, 112.37639921222629],
    [21.32264505445013, 111.57165950386833],
    [21.194646857137904, 111.05803134296698],
    [21.066568578787102, 110.83008361884275],
    [20.766383063064808, 110.72570108148281],
    [20.300834200799134, 110.70647252403879],
    [20.01464522769867, 111.23657084131672],
    [19.76152820742059, 111.27227022928554],
    [18.966034391588668, 110.71746006776131],
    [18.529108123561933, 110.47852728543513],
    [18.21890326914646, 109.98411853490126],
    [18.036205374812994, 109.44306098906232],
    [18.43271883912172, 108.55591398288215],
    [19.1127409928846, 108.5353179330177],
    [19.65033979588037, 108.67125645932957],
    [20.396133798342387, 109.47602470036678],
    [20.7509886892191, 109.51722383871187],
    [20.88959973195503, 109.05028192944022],
    [21.26378708188401, 108.79761187287914],
    [21.575706419244234, 107.99559367912859],
    [22.87744671091661, 106.43555188803384],
    [22.26876357571842, 103.75488313783603],
    [21.2484183203362, 101.03026843314464],
    [24.006324182237677, 98.7011711936196],
    [24.84656629432838, 97.51464911327973],
    [27.644604636756114, 98.04199090356205],
    [28.30438146075165, 95.75683684562246],
    [27.449788517534383, 92.0654287203336],
    [27.761335198556814, 88.46192103407847],
    [29.878753422073952, 81.38671594576918],
    [32.43561292881297, 78.39843876852929],
    [35.42486450996396, 77.65136321330137],
    [38.410563529584195, 74.17969676512392],
    [40.547204766437424, 76.55274079137163],
    [42.45588490009612, 80.28808193157762],
    [43.73935869755203, 80.46387460725231],
    [44.964802251038165, 80.15625672073645],
    [45.33670778667526, 82.17774311914948],
    [46.89022175365102, 83.01267925114901],
    [47.040176782445336, 85.29784443960504],
    [48.22466848196637, 85.64940749323777],
    [49.09544897501817, 86.92382123431634],
    [48.42921007422684, 88.50587296766237],
    [47.48751776611373, 90.52735221077208],
    [46.01221881384681, 91.01073388150422],
    [45.21300692983358, 91.14258227553712],
    [44.52784059909593, 94.35058283797932],
    [44.05601390572493, 95.22949335158074],
    [42.843752197487994, 96.45996364525455],
    [42.682428799755066, 100.98631865952481],
    [41.96765055681946, 104.01854265986125],
    [42.45589934078323, 107.44630257783777],
    [43.67579771768118, 112.01657428289822],
    [44.74675078546885, 111.53322489982838],
    [45.08904930932342, 114.16994753371307],
    [46.52863352928616, 117.59765485820462],
    [46.67960408939562, 119.13575705861527],
    [46.87522455090999, 119.81691991694672],
    [47.72452741536316, 118.95993311962658],
    [47.945772932408964, 117.68552839397582],
    [47.76885441720149, 116.32322243733316],
    [48.297807732829845, 115.72997613554233],
    [49.738670801263765, 116.69675436783425],
    [49.59647525220995, 117.88331210575352],
    [50.722553154477716, 119.57521014157946],
    [51.98487623155457, 120.60790542028046],
    [52.62973718335249, 120.21242455927647],
    [53.40954073762602, 122.5634894357115],
    [53.120386590898924, 125.0463540206469],
    [51.33058938867917, 127.00191258961317],
    [49.6107024686379, 127.92479317256927],
    [48.93691881546189, 130.3198002254561],
    [47.68017514913871, 131.3744993950198],
    [48.12210713532879, 133.11035656576237],
    [48.29779970155954, 134.69235934631243],
    [47.4874985161752, 134.67038525189508],
    [46.255855107081906, 134.12110778246034],
    [44.94923918591576, 133.06639006034712],
    [45.16656906667018, 131.5063813668436],
    [43.818681504544955, 131.11084369314568],
    [42.89204139696846, 131.00094391314468],
    [42.358563355577786, 130.47365809339922],
    [42.56925743246259, 129.61668875721244],
    [41.983997027560484, 128.75976413224686],
    [41.55790383469152, 128.01267252047188],
    [41.672898214601815, 126.95798727265682],
    [40.813797600189076, 126.0571198791167],
  ],
  CHINA_XZQ: [
    [40, 124.5],
    [39, 124.5],
    [37.5, 124.5],
    [37.5, 125.5],
    [33, 125.51],
    [24.88, 125.5],
    [24.87, 124.75],
    [24.87, 122.87],
    [24.63, 122.88],
    [24.62, 122.75],
    [24, 122.75],
    [24, 122.69],
    [23.5, 122.69],
    [23.5, 122.61],
    [23.16, 122.61],
    [23.16, 122.52],
    [22.92, 122.52],
    [22.92, 122.43],
    [22.68, 122.43],
    [22.67, 122.34],
    [22.13, 122.34],
    [22.13, 122.17],
    [21.78, 122.17],
    [21.78, 121.99],
    [21.45, 121.99],
    [21.45, 121.82],
    [21.29, 121.82],
    [21.29, 121.64],
    [21.13, 121.64],
    [21.12, 121.46],
    [20.96, 121.46],
    [20.96, 121.29],
    [20.63, 121.29],
    [20.63, 121.11],
    [20.47, 121.11],
    [20.47, 120.94],
    [20.3, 120.94],
    [20.3, 120.76],
    [20.14, 120.76],
    [20.14, 120.59],
    [19.81, 120.59],
    [19.81, 120.41],
    [19.48, 120.41],
    [19.48, 120.23],
    [19.14, 120.24],
    [19.15, 120.06],
    [18.65, 120.06],
    [18.65, 119.88],
    [18.48, 119.88],
    [18.48, 119.7],
    [18.15, 119.71],
    [18.14, 119.53],
    [17.48, 119.53],
    [17.48, 119.35],
    [16.8, 119.36],
    [16.8, 119.18],
    [12.25, 119.18],
    [12.25, 0x77],
    [11.37, 0x77],
    [11.37, 118.83],
    [11.01, 118.83],
    [11.01, 118.65],
    [10.66, 118.65],
    [10.66, 118.48],
    [10.49, 118.48],
    [10.49, 118.3],
    [10.31, 118.3],
    [10.31, 118.13],
    [9.97, 118.13],
    [9.97, 117.95],
    [9.8, 117.95],
    [9.8, 117.77],
    [9.62, 117.77],
    [9.62, 117.6],
    [9.27, 117.6],
    [9.28, 117.42],
    [9.1, 117.42],
    [9.1, 117.25],
    [8.93, 117.25],
    [8.93, 117.07],
    [8.75, 117.07],
    [8.76, 116.89],
    [8.58, 116.89],
    [8.58, 116.72],
    [8.23, 116.72],
    [8.23, 116.54],
    [8.06, 116.54],
    [8.06, 116.37],
    [7.89, 116.37],
    [7.88, 116.19],
    [7.71, 116.19],
    [7.71, 116.02],
    [7.36, 116.02],
    [7.36, 115.84],
    [7.19, 115.84],
    [7.19, 115.66],
    [7.01, 115.66],
    [7.01, 115.49],
    [6.84, 115.49],
    [6.84, 115.31],
    [6.5, 115.31],
    [6.5, 115.12],
    [6.32, 115.13],
    [6.32, 114.96],
    [6, 114.96],
    [6, 114.75],
    [5.88, 114.75],
    [5.88, 114.5],
    [5.63, 114.5],
    [5.62, 114.37],
    [5.27, 114.38],
    [5.26, 114],
    [4.92, 114],
    [4.92, 113.91],
    [4.57, 113.91],
    [4.56, 113.73],
    [4.39, 113.73],
    [4.39, 113.55],
    [4.04, 113.55],
    [4.04, 113.38],
    [3.86, 113.38],
    [3.86, 113.03],
    [3.69, 113.03],
    [3.69, 112.85],
    [3.51, 112.85],
    [3.51, 112.32],
    [3.34, 112.32],
    [3.34, 109.87],
    [3.88, 109.88],
    [3.87, 109.25],
    [4.5, 109.25],
    [4.5, 108.75],
    [5, 108.75],
    [5, 108.5],
    [5.5, 108.5],
    [6, 108.5],
    [6, 108.12],
    [10.5, 108.12],
    [10.5, 108.75],
    [10.88, 108.75],
    [10.88, 109.13],
    [11.25, 109.12],
    [11.25, 109.37],
    [11.62, 109.38],
    [11.62, 109.75],
    [15.25, 109.75],
    [15.25, 109.5],
    [15.75, 109.5],
    [15.75, 109.25],
    [15.75, 108.75],
    [16.25, 108.75],
    [16.25, 108.25],
    [16.75, 108.25],
    [16.75, 107.75],
    [17.25, 107.75],
    [17.25, 107],
    [18.5, 107],
    [18.5, 106.5],
    [0x14, 106.5],
    [19.97, 96.02],
    [26, 96],
    [26, 78],
    [0x20, 78],
    [31.99, 71.98],
    [51.98, 71.98],
    [52, 115.99],
    [0x38, 115.97],
    [56.01, 132.01],
    [0x32, 131.99],
    [50.01, 136.01],
    [46, 136.02],
    [45.99, 0x86],
    [44, 134.01],
    [44, 131.5],
    [43.25, 131.5],
    [43.25, 131.25],
    [43.13, 131.25],
    [42.75, 131.25],
    [42.75, 130.62],
    [42.63, 130.62],
    [42.62, 130.69],
    [42.5, 130.69],
    [42.5, 130.75],
    [42.25, 130.75],
    [42.25, 130.5],
    [42.5, 130.5],
    [42.5, 130],
    [42.25, 130],
    [42.25, 129.5],
    [41.75, 129.5],
    [41.75, 128.25],
    [41.25, 128.25],
    [41.25, 126.5],
    [40.5, 126.5],
    [40.5, 125.5],
    [40.5, 125.25],
    [40.25, 125.25],
    [40.25, 124.75],
    [40.12, 124.75],
    [40.13, 124.5],
  ] as [number, number][],

  getUrlParam: (url: string) => {
    let search
    if (!url) {
      const locationObject =
        null !== (search = window.location) && undefined !== search
          ? search
          : ({} as any)
      url = locationObject.search || ''
    }

    const params: Record<string, any> = {}
    const queryStartIndex = url.indexOf('?')
    url = url.slice(queryStartIndex + 1)

    const queryParams = url.split('&')
    for (const queryParam of queryParams) {
      const paramParts = queryParam.split('=')
      if (paramParts.length > 1) {
        const paramName = paramParts[0]
        const paramValue = paramParts[1]
        params[paramName] = paramValue
      }
    }

    return params
  },
  getUrlParamLowerCase: (url: string) => {
    let search
    if (!url) {
      const locationObject =
        null !== (search = window.location) && undefined !== search
          ? search
          : ({} as any)
      url = locationObject.search || ''
    }

    const paramsLowerCase: Record<string, any> = {}

    // 去除URL开头的问号和路径部分，只保留查询参数部分
    const queryString = url.replace(/^.*?\?/, '')

    // 获取所有的“key=value”形式的查询参数对
    const keyValuePairs = queryString.match(/\w+=[^&]*/g) || []

    for (const keyValuePair of keyValuePairs) {
      const pair = keyValuePair.split('=')

      // 解码参数名和参数值，并将参数名转为小写
      const paramName = decodeURIComponent(pair[0]).toLowerCase()
      const paramValue = decodeURIComponent(pair[1] || '')

      // 存储参数
      paramsLowerCase[paramName] = paramValue
    }

    return paramsLowerCase
  },
  isEmpty: (
    obj: string | number | null | undefined | [] | string[]
  ): boolean => {
    return null == obj || 0 == `${obj}`.length || !obj
  },
  getObjType: (obj: any) => {
    // 使用Object.prototype.toString.call()方法获取对象的标准内部类名
    let objTypeString = Object.prototype.toString.call(obj)

    // 从结果字符串中提取出类名部分，去除前导空白和尾部方括号
    objTypeString = objTypeString.split(' ')[1]

    // 截取类名，去掉最后的右括号
    objTypeString = objTypeString.slice(
      0,
      Math.max(0, objTypeString.length - 1)
    )

    // 将类名转换为小写形式
    objTypeString = objTypeString.toLowerCase()

    return objTypeString
  },
  dataFormat: (
    data: string | number | Date | dayjs.Dayjs,
    format = 'YYYY-MM-DD HH:mm:ss'
  ) => {
    return dayjs(data).format(format)
  },
  getString: (text: string | null) => (null == text ? '' : `${text}`),
  replaceAll: (data: string, replaceStr: string | RegExp, replacement: any) => {
    if (!data || !replaceStr) return data

    return data.replace(new RegExp(replaceStr, 'g'), replacement)
  },
  getNumber: (
    value: number | string | undefined | null,
    decimals: number,
    type?: string | null
  ) => {
    let number = 0
    if (!value) return 0
    value = Number(value)
    CommUtils.isEmpty(decimals) && (decimals = 0)
    CommUtils.isEmpty(type) && (type = 'floor')
    let pow = 10 ** decimals
    pow <= 0 && (pow = 1)
    switch (type) {
      case 'round':
        number = Math.round(value * pow) / pow
        break
      case 'floor':
      default:
        number = Math.floor(value * pow) / pow
        break
      case 'ceil':
        number = Math.ceil(value * pow) / pow
    }
    return number
  },
  getNumberLEValue: (
    value: number | null | undefined | string,
    maxValue: number,
    divisor: number,
    decimals: number,
    type?: string | null
  ) => {
    if (!value) return
    value = Number(value)
    CommUtils.isEmpty(divisor) && (divisor = 1)
    CommUtils.isEmpty(maxValue) && (maxValue = Number.MAX_VALUE)
    if (value <= maxValue) {
      return CommUtils.getNumber(value / divisor, decimals, type)
    }
    return
  },

  getMousePos: (event: {
    pageX: any
    clientX: number
    pageY: any
    clientY: number
  }) => {
    const scrollLeft =
      document.documentElement.scrollLeft || document.body.scrollLeft
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    return {
      x: event.pageX || event.clientX + scrollLeft,
      y: event.pageY || event.clientY + scrollTop,
    }
  },
  getElementPos: (element: {
    offsetLeft: number
    offsetTop: number
    offsetParent: any
  }) => {
    let x = 0,
      y = 0
    do {
      x += element.offsetLeft
      y += element.offsetTop
      element = element.offsetParent
    } while (null != element)
    return {
      x,
      y,
    }
  },
  getTimeByTimeZone: (offset: number) => {
    const date = new Date()
    const localTime = date.getTime()
    const localOffset = 60000 * date.getTimezoneOffset()
    const utc = localTime + localOffset
    return new Date(utc + 3600000 * offset)
  },
  randomNum: (min = 1, max = 100) =>
    Number.parseInt(`${Math.random() * (max - min + 1) + min}`, 10),
  bindPopup: (
    dom: {
      bindPopup: (arg0: any, arg1: any) => void
      on: (arg0: string, arg1: { (e: any): void; (e: any): void }) => void
    },
    htmlOrText: any,
    options: any
  ) => {
    dom.bindPopup(htmlOrText, options)
    dom.on(
      'mousemove',
      (e: { target: { openPopup: (arg0: any) => void }; latlng: any }) => {
        e.target.openPopup(e.latlng)
      }
    )
    dom.on('mouseout', (e: { target: { closePopup: () => void } }) => {
      e.target.closePopup()
    })
  },
  isHasZH_cn: (text: string) => !!escape(text).includes('%u'),
  msg: (msg?: string) => {
    console.log(msg)
    return true
  },

  setLocalStorage: (key: string, value: any) => {
    if (CommUtils.isEmpty(key)) {
      console.error('setLocalStorage key is null.')
      return
    }
    const options = { data: value, createTime: Date.now() / 1000 }
    window.localStorage.setItem(key, JSON.stringify(options))
  },

  getLocalStorage: (key: string) => {
    if (!CommUtils.isEmpty(key)) {
      const value = window.localStorage.getItem(key) as any
      if (CommUtils.isEmpty(value)) return null
      const jsonValue = JSON.parse(value)
      return jsonValue.data
    }
    console.error('getLocalStorage key is null.')
  },
  setCookie: (key: string, value: any) => CommUtils.setLocalStorage(key, value),
  getCookie: (key: string) => CommUtils.getLocalStorage(key),

  getUuid: (len: number) => {
    if (len) {
      const hexDigits =
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
          ''
        )
      const s: string[] = []
      for (let i = 0; i < len; i++)
        s[i] = hexDigits[0 | (Math.random() * hexDigits.length)]
      return s.join('')
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      return (
        c === 'x' ? Math.trunc(Math.random() * 16) : ('r&0x3' as any | '8')
      ).toString(16)
    })
  },

  getFeatureLabel(
    targetLayer: L.Layer,
    labelText: string,
    labelOptions: LabelOptions
  ): L.Polygon | null {
    labelOptions = merge(
      {
        isShowOutBounds: false,
        repeat: false,
        position: 'lefttop',
        offset: [5, 0],
        attributes: {
          fill: '#fff',
          fontWeight: '400',
          fontSize: '12',
          fontFamily: '微软雅黑',
          xShift: 5,
          yShift: 3,
        },
        pathOptions: {
          color: '',
          weight: 0,
          fillColor: 'rgba(0,0,0,0)',
          fillOpacity: 0.9,
        },
      },
      labelOptions
    )

    const map: L.Map = targetLayer?.['_map'] || labelOptions.map
    let anchorLatLng!: L.LatLng
    let isTargetLayerCenterBased = false

    if (labelOptions.anchorLatLng) {
      anchorLatLng = L.latLng(labelOptions.anchorLatLng)
    } else if (targetLayer) {
      if ('getCenter' in targetLayer) {
        anchorLatLng = (targetLayer as any).getCenter()
        labelOptions.position = 'center'
        isTargetLayerCenterBased = true
      } else if ('getBounds' in targetLayer) {
        anchorLatLng = (targetLayer as any).getBounds().getCenter()
        labelOptions.position = 'center'
        isTargetLayerCenterBased = true
      } else if ((targetLayer as any)._latlng instanceof L.LatLng) {
        anchorLatLng = (targetLayer as any)._latlng
      }
    }

    if (!map || !anchorLatLng || !labelText || labelText === '') {
      return null
    }

    if (!Array.isArray(labelOptions.offset)) {
      labelOptions.offset = [labelOptions.offset, labelOptions.offset]
    }

    const [offsetsX, offsetsY] = labelOptions.offset.map(Number)
    const [textXShift, textYShift] = [
      Number(labelOptions.attributes.xShift) || 0,
      Number(labelOptions.attributes.yShift) || 0,
    ]

    const styles = `${labelOptions.attributes.fontWeight} ${labelOptions.attributes.fontSize}px ${labelOptions.attributes.fontFamily}`
    const labelWidth =
      Number(CommUtils.calcStrLength(map, labelText, styles)) + 2 * textXShift
    const labelHalfWidth = labelWidth / 2
    const labelHeight =
      Number(labelOptions.attributes.fontSize) + 2 * textYShift
    const labelHalfHeight = labelHeight / 2

    const anchorPoint = map!.latLngToLayerPoint(anchorLatLng)
    let labelX = 0
    let labelY = 0

    switch (labelOptions.position) {
      case 'lefttop':
      case 'topleft':
        labelX = anchorPoint.x + offsetsX
        labelY = anchorPoint.y + offsetsY
        break
      case 'left':
        labelX = anchorPoint.x + offsetsX
        labelY = anchorPoint.y - labelHalfHeight
        break
      default:
        labelX = anchorPoint.x - labelHalfWidth
        labelY = anchorPoint.y - labelHalfHeight
    }

    const labelRightX = labelX + labelWidth
    const labelBottomY = labelY + labelHeight

    const topLeftCorner = map.layerPointToLatLng(L.point(labelX, labelBottomY))
    const topRightCorner = map.layerPointToLatLng(
      L.point(labelRightX, labelBottomY)
    )
    const bottomRightCorner = map.layerPointToLatLng(
      L.point(labelRightX, labelY)
    )
    const bottomLeftCorner = map.layerPointToLatLng(L.point(labelX, labelY))

    const labelPolygon = L.polygon(
      [topLeftCorner, topRightCorner, bottomRightCorner, bottomLeftCorner],
      labelOptions.pathOptions
    ) as any

    if (
      isTargetLayerCenterBased &&
      !labelOptions.isShowOutBounds &&
      !(targetLayer as any).getBounds().contains(labelPolygon.getBounds())
    ) {
      return null
    }

    delete labelOptions.isShowOutBounds
    delete labelOptions.position
    delete labelOptions.map
    delete labelOptions.pathOptions
    delete labelOptions.attributes.yShift
    labelOptions.attributes.xShift += 1
    labelOptions.offset = 0 - textYShift - 2
    labelPolygon.setText &&
      labelPolygon.setText(labelText, {
        ...labelOptions,
        attributes: {
          ...labelOptions.attributes,
          'font-family': labelOptions.attributes.fontFamily,
          'font-size': labelOptions.attributes.fontSize,
          'font-weight': labelOptions.attributes.fontWeight,
          x: labelOptions.attributes.xShift,
        },
      })

    return labelPolygon
  },

  calcStrWidthOnCanvas(text: string, font?: string): number {
    if (!text || text.length === 0) {
      return 0
    }
    // 创建并初始化一个临时 canvas 元素
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) {
      return 0
    }
    ctx.font = font || 'bold 12px Arial'
    // 计算文本宽度
    const width = ctx.measureText(text).width
    // 无需在地图容器内操作，所以这里省略了与地图容器相关的DOM操作
    return width
  },
  calcStrLength(map: L.Map, text: string, font?: string): number {
    const width = this.calcStrWidthOnCanvas(text, font)
    // 这里原本的操作已经简化掉，仅保留计算部分
    return width
  },
}

interface LabelOptions {
  isShowOutBounds?: boolean
  anchorLatLng?: L.LatLngExpression
  position?: 'lefttop' | 'left' | 'center' | 'topleft'
  map?: L.Map
  repeat?: boolean
  offset: number | [number, number]
  attributes: {
    fill?: string
    fontWeight?: string
    fontSize?: string
    fontFamily?: string
    xShift: number
    yShift?: number
    offset?: number
  }
  pathOptions?: L.PathOptions
}
